<template>
  <div class="w-full sm:w-3/5 md:w-2/5 mx-auto" v-if="message && role">
    <div
      class="flex justify-between items-center rounded m-2 p-2 text-white"
      :class="{ 'bg-green-400':className === true, 'bg-red-400':className === false }"
    >
      <p>{{ message }}</p>
      <font-awesome-icon icon="times" class="cursor-pointer" @click="dismiss" />
    </div>
  </div>
</template>

<script>
import store from "./../store/index";

export default {
  data() {
    return {
      className: true
    };
  },
  methods: {
    startTimerToDismiss() {
      setTimeout(() => {
        this.dismiss();
      }, 7000);
    },
    dismiss() {
      store.commit("clearMessage");
    }
  },
  computed: {
    message() {
      return this.$store.getters.message;
    },
    role() {
      return this.$store.getters.role;
    }
  },
  watch: {
    message() {
      if (this.message) {
        this.startTimerToDismiss();
      }
    },
    role() {
      if (this.role) {
        if (this.role === "success") {
          this.className = true;
        } else if (this.role === "error") {
          this.className === false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>